import { BaseTabsUpdateComponent } from './../base-tabs-update-component';
import { UserService } from './../../base-services/user.service';
import { BaseEntity } from './../../base-models/base-entity';
import { ActivatedRoute } from '@angular/router';
import { BaseContainer } from './base-container';
import { Tabs2ContainerService } from './services/tabs2-container.service';
import { ViewChild, OnInit } from '@angular/core';
import { BaseContainer2 } from './base-container2';

// extends BaseContainer<T>
export class BaseTabs2Container<T extends BaseEntity> implements OnInit {
   

    constructor(
        protected tabsContainerService2: Tabs2ContainerService<T>,
        // protected activatedRoute: ActivatedRoute,
        protected userService: UserService
    ){
            // super(tabsContainerService, userService);
    }

    // constructor(
    //     protected tabsContainerService: Tabs2ContainerService<T>,
    //     protected activatedRoute: ActivatedRoute,
    //     protected userService: UserService
    // ){
    //         super(tabsContainerService, activatedRoute, userService);
    // }

    @ViewChild('tabSet2', /* TODO: add static flag */ {static: true}) tabSet2;
    @ViewChild('fr', /* TODO: add static flag */ {static: true}) fr;
    @ViewChild('tabs-cont', /* TODO: add static flag */ {static: true}) tabsCont;
    @ViewChild('baseTabsUpdate', /* TODO: add static flag */ {static: false}) baseTabsUpdate: BaseTabsUpdateComponent<T>;

    ngOnInit(){
        // super.ngOnInit();
        this.tabsContainerService2.ActiveTab2.subscribe(activeTab => {
            this.tabSet2.select(activeTab);
            if(activeTab == 'tbUpdate2')
                this.baseTabsUpdate.focus();
        })

        //this.tabsContainerService.ShowUpdate();
        //this.tabsContainerService.ShowList();
    }
        
    SelectList(){
        this.tabsContainerService2.ShowList();
    }

    //AddItem(){
        //this.tabsContainerService.ShowUpdate();
    //}
}
